var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbottitleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63.3986,
    height: 62.1048,
    rx: 31.0524,
    fill: "#4E9FFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6991 29.4372H31.7099M36.0119 29.4372H36.0227M27.3862 29.4372H27.397M42.4812 35.9064C42.4812 36.4784 42.254 37.0268 41.8496 37.4313C41.4451 37.8357 40.8967 38.0629 40.3247 38.0629H26.1226C25.5507 38.063 25.0023 38.2902 24.598 38.6947L22.2238 41.0689C22.1167 41.1759 21.9803 41.2488 21.8318 41.2784C21.6834 41.3079 21.5294 41.2927 21.3896 41.2348C21.2497 41.1769 21.1302 41.0788 21.046 40.9529C20.9619 40.827 20.917 40.679 20.917 40.5276V22.9679C20.917 22.396 21.1442 21.8475 21.5486 21.4431C21.953 21.0387 22.5015 20.8115 23.0734 20.8115H40.3247C40.8967 20.8115 41.4451 21.0387 41.8496 21.4431C42.254 21.8475 42.4812 22.396 42.4812 22.9679V35.9064Z",
    stroke: "white",
    strokeWidth: 2.15642,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbottitleicon);
export default __webpack_public_path__ + "static/media/chatbottitleicon.c9e8762d24a5dfb538b1f3d3f58f00f8.svg";
export { ForwardRef as ReactComponent };